import { Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { valueLimits } from "../../../../constants";
import { formatNumber, validateFloatNum } from "../../../../utils/common";

const DiscountPercent = ({
  total,
  discount,
  final_payable,
  handleBlur,
  errors,
  touched,
  setFieldValue,
}: any) => {
  const [editingField, setEditingField] = useState<
    "discount" | "final_payable" | null
  >(null);

  useEffect(() => {
    if (editingField === "discount") {
      const parsedDiscount = parseFloat(discount);
      const safeDiscount = !isNaN(parsedDiscount) ? parsedDiscount : 0;
      const calculatedPayable = Math.max(
        total - (total * safeDiscount) / 100,
        0
      );
      setFieldValue("final_payable", formatNumber(calculatedPayable));
    } else if (editingField === "final_payable") {
      const parsedFinalPayable = parseFloat(final_payable);
      if (!isNaN(parsedFinalPayable) && total > 0) {
        const calculatedDiscount = Math.max(
          ((total - parsedFinalPayable) / total) * 100,
          0
        );
        setFieldValue("discount", formatNumber(calculatedDiscount));
      } else {
        setFieldValue("discount", "");
      }
    } else {
      const parsedDiscount = parseFloat(discount);
      const safeDiscount = !isNaN(parsedDiscount) ? parsedDiscount : 0;
      const calculated = total - (total * safeDiscount) / 100;
      setFieldValue("final_payable", formatNumber(calculated));
    }

    // Reset editingField after sync
    const timeout = setTimeout(() => setEditingField(null), 0);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount, final_payable, total]);

  return (
    <Stack direction={{ xs: "column", md: "row" }}>
      <TextField
        fullWidth
        id="discount"
        name="discount"
        label="Discount (%)"
        size="small"
        value={discount}
        onChange={(e: any) => {
          const transformedPercentInput = validateFloatNum(e.target.value, {
            min: 0,
          });
          setEditingField("discount");
          setFieldValue("discount", transformedPercentInput);
        }}
        onBlur={handleBlur}
        helperText={errors.discount && touched.discount ? errors.discount : ""}
        error={errors.discount && touched.discount ? true : false}
        sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
        InputLabelProps={{
          required: true,
        }}
      />
      <TextField
        fullWidth
        id="final_payable"
        name="final_payable"
        label="Final payable amount"
        size="small"
        value={!isNaN(Number(final_payable)) ? final_payable : ""}
        onChange={(e: any) => {
          const transformedFinalPayable = validateFloatNum(e.target.value, {
            min: 0,
          });
          setEditingField("final_payable");
          setFieldValue("final_payable", transformedFinalPayable);
        }}
        onBlur={handleBlur}
        helperText={
          errors.final_payable && touched.final_payable
            ? errors.final_payable
            : ""
        }
        error={errors.final_payable && touched.final_payable ? true : false}
        sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
      />
    </Stack>
  );
};

export default DiscountPercent;
